import React from "react";
import { Stack, useMediaQuery } from "@mui/material";
import { useInView } from "react-intersection-observer";
import { animated } from "react-spring";
import theme from "../../../theme";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Link } from "react-router-dom"; // Assumendo che tu stia usando react-router
import useScrollValue from "../../../utils/hooks/useScrollValue";

const SocialIcons = ({
  color,
  isRow,
  isHome,
}: {
  color?: string;
  isRow?: boolean;
  isHome?: boolean;
}) => {
  const [visible, setVisible] = React.useState(false);
  const isLgScreen = useMediaQuery(theme.breakpoints.up("xl"));
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const isLandscape = useMediaQuery("(orientation: landscape)");

  React.useEffect(() => {
    if (inView) {
      setVisible(true);
    }
  }, [inView]);

  const icons = [
    {
      IconComponent: PhoneEnabledIcon,
      link: "tel:+1234567890", // Sostituisci con il numero di telefono reale
      tooltip: "Chiama",
    },
    {
      IconComponent: CalendarMonthIcon,
      link: "/booking", // Route interna per la pagina di prenotazione
      isInternal: true,
      tooltip: "Prenota",
    },
    {
      IconComponent: LocationOnIcon,
      link: "https://maps.google.com/?q=Via+Concezione+a+Montecalvario,+48,+80134+Napoli+NA,+Italia",
      tooltip: "Maps",
    },
  ];
const scrollValue = useScrollValue();
  return (
    <Stack
      ref={ref}
      zIndex={9999999}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "auto",
        display: visible ? "flex" : "none",
        paddingTop:
          isLandscape && isRow
            ? "1.5%"
            : isLgScreen && isRow
            ? "2%"
            : isRow
            ? "5%"
            : undefined,
      }}
      spacing={isRow ? 6 : 2}
      direction={isRow ? "row" : "column"}
    >
      {icons.map((iconData, i) => {
        const IconComponent = iconData?.IconComponent as React.ComponentType<{
          sx: object;
        }>;

        return iconData.isInternal ? (
          <Link key={i} to={iconData.link} style={{ textDecoration: "none" }}>
            <animated.div
              style={{
                backgroundColor: isHome ? "#0c6b8b" : undefined,
                pointerEvents: "auto",
                cursor: "pointer",
                width: isHome ? "37px" : "20px",
                height: isHome ? "37px" : "20px",
                zIndex: 9999999999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50px",
              }}
            >
              <IconComponent sx={{ color: isHome ? "white" : "#0c6b8b" }} />
            </animated.div>
          </Link>
        ) : (
          <animated.div
            key={i}
            style={{
              backgroundColor: isHome ? "#0c6b8b" : undefined,
              pointerEvents: "auto",
              cursor: "pointer",
              width: isHome ? "37px" : "20px",
              height: isHome ? "37px" : "20px",
              zIndex: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50px",
            }}
          >
            {" "}
            <a
              key={i}
              href={iconData?.link}
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "none", color: "white" }}
            >
              <IconComponent sx={{ color: isHome ? "white" : "#0c6b8b" }} />
            </a>
          </animated.div>
        );
      })}
    </Stack>
  );
};

export default SocialIcons;
